import { gql } from 'apollo-angular';
export const auth_queries = {
  getLoggedUser: gql `
    query getLoggedUser{
      getLoggedUser{
        firstName
        lastName
        id
        email
        fullProfile {
          document
          documentTypeId
          genderId
          maritalStatusId
          phone
          birthDate
          occupation
          currentWeight
          bloodType
          stature
          epsId
          scholarshipId
          cityId
          address
          detailAddress
          countryId
          cover
          pathCover
        }
        medicalProfile {
          urlCover
          medicalConfig1{
            appointmentPeriod
            allowInPersonAppointment
            isActive
          }
          medicalConfig2{
            virtualPrice
            inPersonPrice
            isActive
          }
        }
      }
    }
  `,
  getMe: gql `
    query me{
      me{
        firstName
        lastName
        id
        email
        fullProfile {
          document
          documentTypeId
          genderId
          maritalStatusId
          phone
          birthDate
          occupation
          currentWeight
          bloodType
          stature
          epsId
          scholarshipId
          cityId
          address
          detailAddress
          countryId
          cover
        }
       medicalProfile {
          urlCover
          medicalConfig1{
            appointmentPeriod
            allowInPersonAppointment
            isActive
          }
        }
      }
    }
  `
}
